import MapperBase from '../MapperBase.js';
import { Series } from '../../entities/index.js';

class ApexSeriesMapper extends MapperBase {
    constructor(silent, fallback, mapDimensionsToObject = false) {
        super(silent, fallback);
        this.mapDimensionsToObject = !!mapDimensionsToObject;
        this.dimensionsMap = ['x', 'y'];
    }

    dimensionsToObject(point) {
        if (!(point instanceof Array)) {
            return point;
        }

        const mapped = {};

        for (let i = 0; i < point.length; i++) {
            mapped[this.dimensionsMap[i]] = point[i];
        }

        return mapped;
    }

    mapSingle(item) {
        if (!(item instanceof Series)) {
            throw new TypeError('item must be an instance inheriting from Series class');
        }

        if (this.mapDimensionsToObject && item.dimensions > 1) {
            return {
                name: item.name,
                data: item.toArray().map(p => this.dimensionsToObject(p))
            };
        }

        return {
            name: item.name,
            data: item.toArray(),
        };
    }
}

export default ApexSeriesMapper;